document.addEventListener('DOMContentLoaded', function () {
  actionTextSetup();
});

document.addEventListener('turbo:load', function () {
  actionTextSetup();
});

function actionTextSetup() {
  document.addEventListener("trix-file-accept", function (event) {
    if (event.target.classList.contains("no-uploads")) {
      event.preventDefault()
    }
  });
}